import React, { useCallback } from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
} from "react-google-maps";
import ParkingMapMarker from "./map-marker";

const ScooterParkingMap = props => {
  const {
    places,
    handleClick
  } = props;

  const onClick = useCallback((id) => {
    handleClick(places.find(place => place.id === id));
  }, [handleClick, places]);

  return (
    <GoogleMap
      defaultZoom={9}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
    >
      {places.map(place =>
        <ParkingMapMarker
          key={place.id}
          item={place}
          onClick={onClick}
        />)}
    </GoogleMap>
  );
};

ScooterParkingMap.propTypes = {
  places: PropTypes.array,
};

export default withScriptjs(withGoogleMap(ScooterParkingMap));



// WEBPACK FOOTER //
// ./src/views/pages/scooter/parking/map.js